import { takeEvery, fork, put, all, call } from "redux-saga/effects";
// Login Redux States
import { CHECK_LOGIN, LOGOUT_USER } from "./actionTypes";
import { apiError, loginUserSuccessful, logoutUserSuccess } from "./actions";
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import { hostLogin, validateToken } from "../../../api/authAPI";
import { resetFilter } from "../../dbFilter/actions";
import Cookies from "js-cookie";
import { resetLocationData } from "../../locations/actions";
import { resetChargerData, resetForgetUser } from "../../actions";
import storage from "redux-persist/lib/storage";
import { resetUser } from "../../users/actions";
import { resetHost } from "../../hostTech/actions";
import { isTechnician } from "../../../pages/Authentication/userMetaData";

//Initilize firebase
const fireBaseBackend = getFirebaseBackend();

//If user is login then dispatch redux action's are directly from here.
function* loginUser({ payload: { user, history } }) {
  try {
    const token = yield call(hostLogin, user.username, user.password);
    const userData = yield call(validateToken, token, user.isRemember);
    const data = yield put(loginUserSuccessful({ ...userData, token: token }));

    yield put(resetFilter());
    yield put(resetLocationData());
    yield put(resetChargerData());
    yield put(resetForgetUser());
    yield put(resetHost());
    // redirection of home page based on the role
    if (!isTechnician(data?.payload)) {
      history.push("/dashboard");
    } else {
      history.push("/cms-chargers");
    }
  } catch (err) {
    if (err.isErr) {
      console.log("Error Logging in: ", err?.msg);
      console.log("Problem: ", err?.problem);
      yield put(apiError(err?.msg));
    } else {
      console.log("Unexpected Error: ", err);
    }
    return err;
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    yield put(resetFilter());
    yield put(resetLocationData());
    yield put(resetChargerData());
    yield put(resetUser());
    yield put(logoutUserSuccess());
    yield put(resetForgetUser());
    yield put(resetHost());
    storage.removeItem("persist:root"); // Clear persistent state from localStorage
    // yield call([persistor, persistor.purge]);
    Cookies.remove("token"); // Remove token cookie
    sessionStorage.removeItem("token"); // Remove token from sessionStorage
    history.push("/login");
  } catch (err) {
    // Dispatch error action
    // yield put(apiError(error));
    console.log("Unexpected Error: ", err);
  }
}

export function* watchUserLogin() {
  yield takeEvery(CHECK_LOGIN, loginUser);
}

export function* watchUserLogout() {
  yield takeEvery(LOGOUT_USER, logoutUser);
}

function* loginSaga() {
  yield all([fork(watchUserLogin), fork(watchUserLogout)]);
}

export default loginSaga;
